import PaymentsOnDetailSection from 'features/payments/sections/PaymentsOnDetailSection';
import BreadcrumbLink from 'features/shared/components/breadcrumbs/BreadcrumbLink';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import { InvoiceType } from 'features/invoices/enums/invoiceType';
import InvoiceDetailSection from 'features/invoices/sections/InvoiceDetailSection';
import InvoiceDetailLayoutPage from 'features/invoices/pages/InvoiceDetailLayoutPage';
import { useProformaInvoiceIdParam } from 'features/invoices/hooks/useProformaInvoiceIdParam';

export interface InvoiceDetailRouteProps {
  invoiceId: string;
}

interface Props {
  type: InvoiceType;
  backPage: BreadcrumbLink;
}

const InvoiceDetail = ({ type, backPage } : Props) => {
  // router
  const match = useRouteMatch();
  const { invoiceId } = useParams<InvoiceDetailRouteProps>();
  const proformaInvoiceId = useProformaInvoiceIdParam();
  
  // render
  return (
    <Switch>
      <Route path={`${match.path}/payments`}>
        <InvoiceDetailLayoutPage
          type={type}
          links={[backPage]}
          proformaInvoiceId={proformaInvoiceId}
        >
          <PaymentsOnDetailSection 
            filterByName='InvoiceId'
            filterByValue={invoiceId}
            proformaInvoiceId={proformaInvoiceId}
          />
        </InvoiceDetailLayoutPage>
      </Route>
      <Route path={`${match.path}/detail`}>
        <InvoiceDetailLayoutPage
          type={type}
          links={[backPage]}
          showLinkToDetail={false}
          proformaInvoiceId={proformaInvoiceId}
        >
          <InvoiceDetailSection 
            invoiceId={invoiceId} 
            proformaInvoiceId={proformaInvoiceId} 
          />
        </InvoiceDetailLayoutPage>
      </Route>
    </Switch>
  );
}

export default InvoiceDetail;
